const ResearchId = {
  SHIELDS: "etoa:shields",
  ARMOR: "etoa:armor",
  WEAPONS: "etoa:weapons",
  REGENERATION: "etoa:regeneration"
};

export { ResearchId };
